const formatDate = () => {
    let currentTime = new Date()
        .toISOString()
        .replace(/[^0-9]/g, "")
        .slice(0, -3);
    let totalDate = currentTime && currentTime.substring(2);
    return totalDate;
};

export default formatDate;
